import styled from 'styled-components'
import { radiuses, colors } from 'styles'

const CheckboxCustom = styled.div`
  position: absolute;
  display: inline-block;
  height: 1em;
  width: 1em;
  color: ${colors.textMain};
  background: ${colors.mainBackground};
  border: 0.07em solid; /* ${colors.textMain} */
  border-radius: ${radiuses.small};
  box-sizing: border-box;
  line-height: 0;
  label {
    user-select: none;
  }

  .checkmark {
    visibility: hidden;
    position: absolute;
    top: 0;
    right: -0.25em;
    height: 1em;
    width: 1em;

    svg {
      path {
        stroke: ${colors.mainBackground};
        /* fill: ${colors.textMain}; */
      }
    }
  }
`

const StyledCheckbox = styled.div`
  display: flex;
  align-items: center;
  position: relative;

  &:focus-within ${CheckboxCustom} {
    box-shadow: 0 0 1rem;
  }

  input {
    position: absolute;
    opacity: 0;
    z-index: -1;
    pointer-events: none;

    &:checked ~ ${CheckboxCustom} .checkmark {
      visibility: visible;
    }
  }
  padding: 1rem 0;

  label {
    padding-left: 1.5em;
    color: ${colors.textMain};
    position: relative; /* in order to be on top */
    user-select: none;
  }
`

export default StyledCheckbox
export { CheckboxCustom }
